import { render, staticRenderFns } from "./DocumentPortalComplete.vue?vue&type=template&id=2e096f24&scoped=true&"
import script from "./DocumentPortalComplete.vue?vue&type=script&setup=true&lang=js&"
export * from "./DocumentPortalComplete.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DocumentPortalComplete.vue?vue&type=style&index=0&id=2e096f24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e096f24",
  null
  
)

export default component.exports